import { render } from "./deptPoItem.vue?vue&type=template&id=08a09462"
import script from "./deptPoItem.vue?vue&type=script&lang=js"
export * from "./deptPoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__